
import pb from "../../utils/pocketbase";
import axiosInstance from "../../utils/axios";
import Swal from "sweetalert2";
pb.autoCancellation(false)
// const record = await pb.collection('transactions').create(data);
export const getTransactions = async (serverDate) => {

    try {
        const response = await axiosInstance.get('transactions/getData.php');
        return response.data
    } catch (error) {
        console.error('Error:', error);
    }

};

export const addTransaction = async (data) => {
    const inv_id = 'TR' + Date.now().toString().slice(-4);
    try {
        const response = await axiosInstance.post('/transactions/createData.php', {
            data:data,
            inv_id:inv_id
        });
        console.log(response.data);
        Swal.fire({
            position: "center",
            icon: "success",
            title: "Task completed..!",
            showConfirmButton: false,
            timer: 1500
          });
        // Handle success, show success message, update UI, etc.
      } catch (error) {
        Swal.fire({
            position: "center",
            icon: "error",
            title: error,
            showConfirmButton: false,
            timer: 1500
          });
        console.error('Error:', error);
        // Handle error, show error message, etc.
      }

};

export const editTransaction = async (id, data) => {
    try {
        const response = await axiosInstance.put('/transactions/updateData.php', {
            data:data,
            id:id
        });
        console.log(response.data);
        // Handle success, show success message, update UI, etc.
      } catch (error) {
        console.error('Error:', error);
        // Handle error, show error message, etc.
      }
};

export const deleteTransaction = async (id) => {
    
    try {
        const response = await axiosInstance.delete(`/transactions/deleteData.php?id=${id}`);
    return response
    } catch (error) {
        console.error('Error:', error);
    }
};
